<template>
  <div class="introducer-report">
    <el-tabs v-model="tabActive" @tab-click="setTabActive" type="border-card">
      <el-tab-pane label="Downline" name="downline">
        <Downline />
      </el-tab-pane>
      <el-tab-pane label="Income" name="income">
        <Income />
      </el-tab-pane>
      <el-tab-pane label="Bonus Summary" name="bonussummary">
        <Bonussmmary />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Downline from "./downline";
import Income from "./income";
import Bonussmmary from "./bonus-smmary";
export default {
  components: {
    Downline,
    Income,
    Bonussmmary,
  },
  data(){
    return {
      tabActive: this.$route.query.subtab || "downline",
    }
  },
  methods:{
    setTabActive(tab) {
      let maintab = this.$route.query.tab;
      let subtab = tab.name;
      let project_uid = this.$route.params.project_uid;
      let enduser_id = this.$route.params.customer_uid;
      //tabActive = tab.name;
      this.$router.push(
        `/customer/view/${project_uid}/${enduser_id}?tab=${maintab}&subtab=${subtab}`
      );
    },
  }
};
</script>

<style></style>
